<div class="accessibility">
    <div class="heading">
        <h5>Accessibility Options</h5>
        <span (click)="closeAccess()">Close
            <!-- Icon change -->
            <mat-icon style="vertical-align:middle;">close</mat-icon>
            <!-- <i class="bi bi-x-lg"></i> -->
        </span>
    </div>
    <div class="options">
        <div class="sec1">
            <div class="option">
                <span>Text Size </span>
                <span class="btns">
                    <button class="text-design" (click)="setTextSize('zoomOut')"
                        [ngClass]="{'active': activeBtn === 'zoomOut'}">A-</button>
                    <button (click)="setTextSize('normal')" [ngClass]="{'active': activeBtn === 'normal'}">A</button>
                    <button (click)="setTextSize('zoomIn')" [ngClass]="{'active': activeBtn === 'zoomIn'}">A+</button>
                </span>
            </div>
            <div class="option">
                <span>Dark Mode </span>
                <!-- <mat-slide-toggle [(ngModel)]="darkModeEnabled" (change)="onDarkModeToggle()"></mat-slide-toggle> -->
                <!-- DarkModechanges -->
                <mat-slide-toggle [(ngModel)]="darkModeEnabled" #darkModeSwitch
                    (change)="onDarkModeToggle()"></mat-slide-toggle>
            </div>
            <div class="option">
                <span>High Contrast Mode </span>
                <!-- DarkModechanges -->
                <mat-slide-toggle [(ngModel)]="highContrastEnabled" #highContrastSwitch
                    (change)="toggleHighContrast()"></mat-slide-toggle>
                <!-- <mat-slide-toggle [(ngModel)]="highContrastEnabled" (change)="onHighContrastToggle()"></mat-slide-toggle> -->
            </div>
        </div>
        <div class="sec2">
            <!-- <button class="option" (click)="readyToListen ? disableSpeech() : enableSpeech()" *ngIf="isLoggedIn">
                <span>Listen to Page</span>
                <i *ngIf="!readyToListen" class="bi bi-volume-mute"></i>
                <i *ngIf="readyToListen" class="bi bi-volume-up"></i>
                </button> -->
            <!-- <div class="sec1" *ngIf="isLoggedIn">
                <button class="option" (click)=keyshortCut()>
                    <span class="label-keyboard">Keyboard Shortcuts List</span><i class="bi bi-keyboard"></i>
                </button>
            </div> -->
        </div>
    </div>
    <div class="reset">
        <button class="reset-btn" (click)="reset()">Reset</button>
    </div>
</div>